import { gql } from '@apollo/client';

import {
  RemoveHyperbeamSessionDocument,
  type RemoveHyperbeamSessionMutation,
  type RemoveHyperbeamSessionMutationVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    mutation RemoveHyperbeamSession($input: RemoveHyperbeamSessionInput!) {
      removeHyperbeamSession(input: $input)
    }
  `;
}

export const REMOVE_HYPERBEAM_SESSION = RemoveHyperbeamSessionDocument;
export type {
  RemoveHyperbeamSessionMutation,
  RemoveHyperbeamSessionMutationVariables,
};
